export let ServiceTemplateBundlePricingTypeEnum = /*#__PURE__*/function (ServiceTemplateBundlePricingTypeEnum) {
  ServiceTemplateBundlePricingTypeEnum["Fixed"] = "fixed";
  ServiceTemplateBundlePricingTypeEnum["Variable"] = "variable";
  return ServiceTemplateBundlePricingTypeEnum;
}({});